import type { CallablesMap } from "@aircap/common/callables";

export const isTreezorDocumentFile = (file: File) => {
  let fileExtension = file.name.split(".").pop()?.toLowerCase();
  if (fileExtension === "jpeg") fileExtension = "jpg";
  if (fileExtension === "tiff") fileExtension = "tif";
  return (
    fileExtension === "jpg" ||
    fileExtension === "png" ||
    fileExtension === "svg" ||
    fileExtension === "tif" ||
    fileExtension === "pdf"
  );
};

export const postTreezorDocumentUpload = async (
  upload: CallablesMap["createTreezorDocumentUploadForUser"]["response"],
  file: File,
) => {
  const body = new FormData();
  for (const [key, value] of Object.entries(upload.formFields)) {
    if (typeof value !== "string" && typeof value !== "number" && typeof value !== "boolean") {
      throw new Error(`Unexpected upload form field type for ${key}`);
    }
    body.append(key, value.toString());
  }
  body.append("file", file);

  // Treezor's S3 bucket returns 204 without Access-Control-Allow-Origin, so a
  // normal CORS fetch throws even when the upload succeeded. `no-cors` still
  // sends the multipart POST and yields an opaque response we treat as success.
  const uploadResponse = await fetch(upload.form.action, {
    method: upload.form.method,
    body,
    mode: "no-cors",
  });
  if (uploadResponse.type !== "opaque" && !uploadResponse.ok) {
    throw new Error(`Document upload failed with status ${uploadResponse.status}`);
  }
};
